"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePositionLimit = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
const react_1 = require("react");
const useListenOrderStatusChange_1 = require("../SimpleFuturesOrderProcessor/useListenOrderStatusChange");
/**
 * 异步获取开仓限额的名义价值
 * @param params
 */
function usePositionLimit(params) {
    const [state, doFetch] = (0, common_business_1.useAsyncFn)((innerParams) => {
        return SimpleFuturesAPI_1.SimpleFuturesAPI.getPositionLimit(innerParams).toPromise();
    });
    (0, react_1.useEffect)(() => {
        doFetch(params);
        // 参数变化重新请求
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.base, params.quote, params.leverage, params.exchange]);
    const orderListener = (0, common_business_1.usePersistFn)(() => {
        // 仓位变化，刷新限额
        setTimeout(() => {
            // 后端查询额度会慢于推送，做一个延时请求
            doFetch(params);
        }, 2000);
    });
    (0, useListenOrderStatusChange_1.useListenOrderStatusChange)({ base: params.base, quote: params.quote }, orderListener);
    return state;
}
exports.usePositionLimit = usePositionLimit;
